import React from 'react';
import { twMerge } from 'tailwind-merge';
import { SENDGRID_TEMPLATE_IDS, getLifecycleCommsHeader } from '@scale/shared/email';

// these elements' default styles are overridden by scale styles -> reset
const TagsToRevert = ['h1', 'h2', 'blockquote', 'ol', 'ul'];

const TemplatePreview = ({
  templateHTML,
  content,
  subject,
  sendgridTemplateId,
  className = '',
  removeBorder = false,
}: {
  templateHTML: string;
  content: string;
  subject: string;
  sendgridTemplateId?: string;
  className?: string;
  removeBorder?: boolean;
}) => {
  // hard to sanitize because of image and style links; don't for now..
  // relies on sendgrid template having '<%body%>' as a placeholder

  // For lifecycle comms template, format body to include subject in h2 (matching backend logic)
  // Only format if the body doesn't already contain the lifecycle header (to avoid double-formatting)
  const isLifecycleCommsTemplate = sendgridTemplateId === SENDGRID_TEMPLATE_IDS.LIFECYCLE_COMMS;
  const alreadyContainsHeader = content.includes('data-lifecycle-header');
  const bodyContent =
    isLifecycleCommsTemplate && !alreadyContainsHeader
      ? `${getLifecycleCommsHeader(subject)}${content}`
      : content;

  let html = templateHTML
    .replace('<%body%>', bodyContent)
    .replace('<pre', '<pre style="white-space: pre-wrap"') // gmail uses pre-wrap but not chrome
    .replace(
      /<a(?![^>]*background-color)/g,
      '<a style="all:revert; pointer-events: none; cursor: default;"',
    );
  // Apply revert styles to regular links but exclude CTA buttons
  // CTA buttons typically have background-color styling

  TagsToRevert.forEach(tag => {
    // Exclude lifecycle comms header from revert logic
    const regex = new RegExp(`<${tag}(?![^>]*data-lifecycle-header)`, 'g');
    html = html.replace(regex, `<${tag} style="all:revert;"`);
  });

  return (
    <div
      className={twMerge(
        'rounded p-8 h-full overflow-y-auto w-full text-wrap whitespace-normal',
        !removeBorder && 'border border-solid border-neutral-200',
        className,
      )}
    >
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};

export default TemplatePreview;
